export const GET_SETTINGS = 'GET_SETTINGS';
export const SET_BACKGROUND_IMAGE = 'SET_BACKGROUND_IMAGE'; 